module.exports = __webpack_public_path__ + "static/media/Overbite (deep bite)2.362ab0b4.png";